import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

RatingSelector.propTypes = {
	assessment: PropTypes.object,
	ratingsDataEditor: PropTypes.object,
	label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default function RatingSelector({
	label,
	assessment,
	ratingsDataEditor,
}) {
	const getStyles = () => ({
		display: 'flex',
		alignItems: 'center',
		marginBottom: '1.5rem',
		justifyContent: 'space-between',
	});

	const getOptions = () => {
		const options = [];
		for (let i = 1; i <= 10; i++) {
			options.push(i);
		}
		return options;
	};

	const renderOneOption = (option, idx) => {
		const optionAsValue = option.toString();
		return (
			<Select.Option key={idx} value={optionAsValue}>
				{`${optionAsValue} / 10`}
			</Select.Option>
		);
	};

	const assignDefaultValue = () => {
		if (assessment.value > -1) {
			return assessment.value.toString();
		}
		return undefined;
	};

	const onSelectOption = value => {
		const next = typeof value === 'string' ? Number(value) : -1;
		ratingsDataEditor.update({ ...assessment, value: next });
	};

	return (
		<div className="rating-selector">
			<div style={getStyles()}>
				<span>{label}</span>
				<Select
					placeholder="1 - 10"
					defaultValue={assignDefaultValue()}
					onChange={onSelectOption}
					style={{ minWidth: 120 }}>
					{getOptions().map(renderOneOption)}
				</Select>
			</div>
		</div>
	);
}
